/**
 * Sets a query parameter in history.
 *
 * @private
 */
export const setQueryParam = ({ history, location, parameter, replace, value }) => {
  const { search } = location;
  const queryParams = new URLSearchParams(search);

  if (value) {
    queryParams.set(parameter, value);
  } else {
    queryParams.delete(parameter);
  }

  // Remove VUE_APP_BASE_URL from pathname if it's defined
  let pathname = location.pathname;
  if (import.meta.env.VUE_APP_BASE_URL) {
    const baseUrl = import.meta.env.VUE_APP_BASE_URL;
    if (pathname.startsWith(baseUrl)) {
      pathname = pathname.substring(baseUrl.length);
    }
    if (!pathname.startsWith("/")) {
      pathname = `/${pathname}`;
    }
  }

  const destination = `${pathname}?${queryParams.toString()}`;

  if (replace) {
    history.replace(destination);
  } else {
    history.push(destination);
  }
};
